module.exports = __webpack_public_path__ + "img/detail.d95f161c.svg";